var _defs, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20.2,
    cy: 20.2,
    r: 3.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.3,13.3c-.2-.5-.5-.9-.9-1.3-.4-.4-.8-.7-1.3-.9-.4-.2-1-.4-2.2-.4h-9.4c-1.1,0-1.8.2-2.2.4-.5.2-.9.5-1.3.9s-.7.8-.9,1.3c-.2.4-.4,1-.4,2.2v9.4c0,1.1.2,1.8.4,2.2.2.5.5.9.9,1.3s.8.7,1.3.9c.4.2,1,.4,2.2.4h9.4c1.1,0,1.8-.2,2.2-.4.5-.2.9-.5,1.3-.9s.7-.8.9-1.3c.2-.4.4-1,.4-2.2v-9.4c0-1.1-.2-1.8-.4-2.2ZM20.2,26.1c-3.3,0-6-2.7-6-6s2.7-6,6-6,6,2.7,6,6-2.7,6-6,6ZM26.5,15.3c-.8,0-1.4-.6-1.4-1.4s.6-1.4,1.4-1.4,1.4.6,1.4,1.4-.6,1.4-1.4,1.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M.2,20c.1,25.9,39.4,25.9,39.6,0C39.7-5.9.3-5.9.2,20ZM31.8,25c0,1.2-.2,2.1-.5,2.8-.3.8-.7,1.4-1.4,2.1s-1.3,1-2.1,1.4c-.7.3-1.6.5-2.8.5h-9.6c-1.2,0-2.1-.2-2.8-.5-.8-.3-1.4-.7-2.1-1.4s-1.1-1.3-1.4-2.1c-.3-.7-.5-1.6-.5-2.8v-9.6c0-1.2.2-2.1.5-2.8.3-.8.7-1.4,1.4-2.1s1.3-1.1,2.1-1.4c.7-.3,1.6-.5,2.8-.5h9.6c1.2,0,2.1.2,2.8.5.8.3,1.4.7,2.1,1.4.6.6,1,1.3,1.4,2.1.3.7.5,1.6.5,2.8v9.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramNew);
export default __webpack_public_path__ + "static/media/instagram_new.fd2eed2b282773bdaa5ea60fa51534a7.svg";
export { ForwardRef as ReactComponent };